import { render, staticRenderFns } from "./MainStage.vue?vue&type=template&id=008766e8&scoped=true&"
import script from "./MainStage.vue?vue&type=script&lang=js&"
export * from "./MainStage.vue?vue&type=script&lang=js&"
import style0 from "./MainStage.vue?vue&type=style&index=0&id=008766e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008766e8",
  null
  
)

export default component.exports